import { useCallback } from "react";
import api from "../../services/api";

const useCompanies = () => {

    const save = useCallback(async (data) => {
        try {
            console.log('🔍 Criando empresa:', data);
            const response = await api.post('/companies', data);
            console.log('✅ Empresa criada com sucesso:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Erro ao criar empresa:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                statusText: error.response?.statusText
            });
            throw error;
        }
    }, []);

    const findAll = useCallback(async (id) => {
        const { data } = await api.get(`/companies`);
        return data;
    }, []);

    const list = useCallback(async (id) => {
        const { data } = await api.get(`/companies/list`);
        return data;
    }, []);

    const find = useCallback(async (id) => {
        const { data } = await api.get(`/companies/${id}`);
        return data;
    }, []);

    const update = useCallback(async (data) => {
        const { data: responseData } = await api.put(`/companies/${data.id}`, data);
        return responseData;
    }, []);

    const remove = useCallback(async (id) => {
        const { data } = await api.delete(`/companies/${id}`);
        return data;
    }, []);

    const updateSchedules = useCallback(async (data) => {
        const { data: responseData } = await api.put(`/companies/${data.id}/schedules`, data);
        return responseData;
    }, []);

    // New functions for blocking and cleaning company files
    const toggleBlockStatus = useCallback(async (id) => {
        try {
            console.log('🔍 Alterando status da empresa:', id);
            const response = await api.request({
                url: `/companies/${id}/toggle-status`,
                method: 'PATCH'
            });
            console.log('✅ Status alterado com sucesso:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Erro ao alterar status da empresa:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                statusText: error.response?.statusText,
                companyId: id
            });
            throw error;
        }
    }, []);

    const cleanCompanyFiles = useCallback(async (id) => {
        try {
            console.log('🔍 Limpando arquivos da empresa:', id);
            const response = await api.delete(`/companies/${id}/files`);
            console.log('✅ Arquivos limpos com sucesso:', response.data);
            return response.data;
        } catch (error) {
            console.error('❌ Erro ao limpar arquivos da empresa:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                statusText: error.response?.statusText,
                companyId: id
            });
            throw error;
        }
    }, []);

    return {
        save,
        update,
        remove,
        list,
        find,
        findAll,
        updateSchedules,
        toggleBlockStatus,
        cleanCompanyFiles
    }
}

export default useCompanies;